import './index.scss'
import Swiper from 'swiper/js/swiper.min.js'

var nyNavswiper
var nyswiperisinit = false
var winW = $(window).width()
$(document).ready(function(){
  navswiperinit()
  let index = $('.ny-nav .mySwiper .swiper-slide.active').index()
  nyNavswiper.slideTo(index,0)
})

function navswiperinit(){
  nyNavswiper = new Swiper(".ny-nav .mySwiper", {
    slidesPerView:  3.5, 
    resizeObserver: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    watchOverflow: true,//因为仅有1个slide，swiper无效
    navigation: {
      nextEl: ".ny-nav .swiper-button-next",
      prevEl: ".ny-nav .swiper-button-prev",
    },
    breakpoints: {
      1025: {
        slidesPerView: 7.5,
      },
      769: {
        slidesPerView: 5.5,
      },
      640: {
        slidesPerView: 5.5,
      }
    },
    on: {
      init: function(swiper){
        if(winW >= 768){
          if(this.isLocked){
            $('.ny-nav .swiper-btn').hide()
          }else{
            $('.ny-nav .swiper-btn').show()
          }
        }
        setTimeout(function(){
          if($('.ny-nav .swiper-button-prev').hasClass('swiper-button-disabled')){
            $('.ny-nav .left-mask').fadeOut()
          }else{
            $('.ny-nav .left-mask').fadeIn()
          }
  
          if($('.ny-nav .swiper-button-next').hasClass('swiper-button-disabled')){
            $('.ny-nav .right-mask').fadeOut()
          }else{
            $('.ny-nav .right-mask').fadeIn()
          }
        },200)
      },
      transitionEnd: function(){
        if($('.ny-nav .swiper-button-prev').hasClass('swiper-button-disabled')){
          $('.ny-nav .left-mask').fadeOut()
        }else{
          $('.ny-nav .left-mask').fadeIn()
        }

        if($('.ny-nav .swiper-button-next').hasClass('swiper-button-disabled')){
          $('.ny-nav .right-mask').fadeOut()
        }else{
          $('.ny-nav .right-mask').fadeIn()
        }
      },
      resize: function(){
        this.update(); //窗口变化时，更新Swiper的一些属性，如宽高等
        if(winW >= 768){
          if(this.isLocked){
            $('.ny-nav .swiper-btn').hide()
          }else{
            $('.ny-nav .swiper-btn').show()
          }
        }
      },
    },
  });
}
